module.exports = __webpack_public_path__ + "img/trophee_off.b292a6bc.gif";